import { useState } from 'react';
import Button from '../ui/Button';
import './FieldToolbar.css';

const FieldToolbar = ({ onAddField, onDragStart }) => {
  const [activeField, setActiveField] = useState(null);

  const fieldTypes = [
    { id: 'signature', label: 'Signature', icon: '✍️' },
    { id: 'initial', label: 'Initial', icon: '🖋️' },
    { id: 'date', label: 'Date', icon: '📅' },
    { id: 'text', label: 'Text Box', icon: '📝' },
    { id: 'checkbox', label: 'Checkbox', icon: '✓' },
  ];

  const handleFieldClick = (fieldType) => {
    if (activeField === fieldType.id) {
      setActiveField(null);
      onAddField && onAddField(null);
    } else {
      setActiveField(fieldType.id);
      onAddField && onAddField(fieldType.id);
    }
  };

  const handleDragStart = (e, fieldType) => {
    // Set data for drag operation
    e.dataTransfer.setData('text/plain', fieldType.id);
    
    // Store detailed data as JSON
    const dragData = JSON.stringify({
      fieldType: fieldType.id,
      isNew: true
    });
    
    try {
      e.dataTransfer.setData('application/json', dragData);
    } catch (err) {
      console.error('Error setting JSON data:', err);
      // Fallback for browsers that don't support complex data types
      e.dataTransfer.setData('text/plain', `${fieldType.id}:new`);
    }
    
    e.dataTransfer.effectAllowed = 'copy';
    
    // Create a drag image
    const dragImage = document.createElement('div');
    dragImage.className = `field-drag-image field-${fieldType.id}`;
    dragImage.innerHTML = `
      <span class="field-button-icon">${fieldType.icon}</span>
      <span class="field-button-label">${fieldType.label}</span>
    `;
    document.body.appendChild(dragImage);
    
    // Set the drag image
    try {
      e.dataTransfer.setDragImage(dragImage, 25, 25);
    } catch (err) {
      console.error('Error setting drag image:', err);
      // Some browsers might not support setDragImage
    }
    
    // Notify parent component
    onDragStart && onDragStart(fieldType.id);
    
    // Remove the drag image element after a short delay
    setTimeout(() => {
      document.body.removeChild(dragImage);
    }, 0);
  };

  return (
    <div className="field-toolbar">
      <div className="field-toolbar-title">Add Fields</div>
      <div className="field-buttons">
        {fieldTypes.map((fieldType) => (
          <button
            key={fieldType.id}
            className={`field-button ${activeField === fieldType.id ? 'active' : ''}`}
            onClick={() => handleFieldClick(fieldType)}
            draggable="true"
            onDragStart={(e) => handleDragStart(e, fieldType)}
            type="button"
          >
            <span className="field-button-icon">{fieldType.icon}</span>
            <span className="field-button-label">{fieldType.label}</span>
          </button>
        ))}
      </div>
      <div className="field-toolbar-instructions">
        <p>Drag fields directly onto the document where you need them signed.</p>
        <p>Or click a field type above and then click on the document.</p>
        <p>Drag existing fields to reposition them.</p>
      </div>
    </div>
  );
};

export default FieldToolbar;
